export default "__VITE_ASSET__Bp0FH7sy__"